<nav class="navbar navbar-expand-lg navbar-light w-100 z-2">
  <div class="container" [ngClass]="{ ar: translate.currentLang === 'ar' }">
    <div class="d-flex justify-content-between align-items-center w-100">
      <a class="navbar-brand py-0 m-0" routerLink="/">
        <img
          [src]="'assets/images/logo.png'"
          alt="Trip Hands"
          class="nav-logo"
        />
      </a>

      <div id="navbarNavDropdown" *ngIf="screenWidth <= 992">
        <button mat-button>
          <img width="20" height="14" [src]="ImgUrl" />
        </button>

        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="EgCurr()">
            <img
              class="flag"
              src="../../../../assets/icons/flags/egy.svg"
              alt="EGP"
            />
          </button>
          <button mat-menu-item (click)="KWCurr()">
            <img
              class="flag"
              src="../../../../assets/icons/flags/kwt.svg"
              alt="KWD"
            />
          </button>
        </mat-menu>

        <button mat-button [matMenuTriggerFor]="lang">
          <img width="20" src="assets/icons/global.svg" />
          <span class="text-white">
            {{ translate.currentLang.toUpperCase() }}</span
          >
        </button>

        <mat-menu #lang="matMenu">
          <button
            class="langBtn"
            mat-button
            class="nav-link"
            (click)="updateLang('ar')"
          >
            AR
          </button>
          <button
            class="langBtn en"
            mat-button
            class="nav-link"
            (click)="updateLang('en')"
          >
            EN
          </button>
        </mat-menu>

        <ng-container *ngIf="this.Utilities.selectedCurrency">
          <button
            mat-button
            [matMenuTriggerFor]="currencyMenu"
            class="nav-link"
          >
            {{ this.Utilities.selectedCurrency["Currency_Code"] }}
          </button>
        </ng-container>
      </div>
    </div>

    <div
      class="navbar-collapse justify-content-center"
      id="navbarNavDropdown"
      *ngIf="screenWidth > 992"
    >
      <ul class="navbar-nav align-items-center">
        <!-- Currency -->
        <li class="d-flex align-items-center gap-1 mx-2 contact-us-btn" (click)="goToContactUs()">
          <img src="assets/icons/contact-us-icon.svg" />
          <span class="text-white fs-bold flex-grow-1 bg-dark rounded-2">0227730393-99</span>
        </li>
        <li class="nav-item mx-2 PointDiv">
          <button mat-button>
            <img width="20" height="14" [src]="ImgUrl" />
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="EgCurr()">
              <img
                class="flag"
                src="../../../../assets/icons/flags/egy.svg"
                alt="EGP"
              />
            </button>
            <button mat-menu-item (click)="KWCurr()">
              <img
                class="flag"
                src="../../../../assets/icons/flags/kwt.svg"
                alt="KWD"
              />
            </button>
          </mat-menu>
        </li>
        <li class="nav-item mx-2 langDiv">
          <div class="d-flex nav-link p-0">
            <button
              class="langBtn"
              mat-button
              class="nav-link"
              (click)="updateLang('ar')"
            >
              AR
            </button>
            <button
              class="langBtn en"
              mat-button
              class="nav-link"
              (click)="updateLang('en')"
            >
              EN
            </button>
          </div>
        </li>
        <li class="nav-item mx-2 CurrencyDiv">
          <ng-container *ngIf="this.Utilities.selectedCurrency">
            <button
              mat-button
              [matMenuTriggerFor]="currencyMenu"
              class="nav-link"
            >
              {{ this.Utilities.selectedCurrency["Currency_Code"] }}
            </button>
          </ng-container>
        </li>

      </ul>
    </div>
  </div>
</nav>

<mat-menu #currencyMenu="matMenu">
  <button
    mat-menu-item
    *ngFor="let currency of this.Utilities.allCurrency"
    (click)="updateCurrency(currency)"
  >
    <img width="20" height="14" [src]="currency.Image_Url" />{{
      currency["Currency_Code"]
    }}
  </button>
</mat-menu>
